import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuVersions`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuVersions`, payload);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/menuVersions/${id}`);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menuVersions/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/menuVersions/${id}`, payload);
};

const publish = (merchantId, id, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/menuVersions/${id}/publish`,
		payload
	);
};

// payload : {
//   "effectiveTime": "2022-10-12T02:48:14.981Z",
//   "operateBy": "string"
// }
const rollback = (merchantId, id, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/menuVersions/${id}/rollback`,
		payload
	);
};

const sameAsUniversal = (merchantId, id, payload) => {
	return Client.del(
		`${baseUrl}/${merchantId}/menuVersions/${id}/sameAsUniversal`,
		payload
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	publish,
	rollback,
	sameAsUniversal,
};
